import { AxiosConfigAdmin } from "Admin/Config/AxiosConfig";
import { refreshToken } from "./Auth";
export const getFacultyList = (name, callback) => {
  const axios = AxiosConfigAdmin();
  let url = `/faculty-members`;
  if (name) {
    url += `?name=${name}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getFacultyList(name, callback));
      } else {
        callback(err.response.data);
      }
    });
};
